import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent {
  _showModal!: boolean;
  _sourceComponent!: string;
  @Input() set showModal(value: boolean) {
    this._showModal = value;
    if (this._showModal) {
      this.openModal();
    }
  }
  @Input() set sourceComponent(value: string) {
    this._sourceComponent = value;
  }
  @Input() customBgColor = '';
  @Output()
  closeModal = new EventEmitter();
  public modalRef!: ElementRef;
  public closeModalRef!: ElementRef;
  @ViewChild('modal') set modalContent(content: ElementRef) {
    if (content) {
      this.modalRef = content;
    }
  }
  @ViewChild('closeModalRef') set closeModalContent(content: ElementRef) {
    if (content) {
      this.closeModalRef = content;
    }
  }

  constructor() {}

  _closeModal($e: Event) {
    if (this.modalRef && this.modalRef.nativeElement) {
      this.modalRef.nativeElement?.setAttribute('aria-hidden', 'true');
    }
    this._showModal = false;
    document.documentElement.style.overflow = 'auto';
    document.body?.setAttribute('aria-hidden', 'false');
    this.closeModal.emit();
    $e.stopPropagation();
  }

  @HostListener('window:keydown', ['$event'])
  eventHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this._closeModal(event);
    }
    if (event.key === 'Tab') {
      if (this._showModal) {
        this.closeModalRef?.nativeElement.focus();
        event.preventDefault();
      }
    }
  }

  openModal() {
    document.documentElement.style.overflow = 'hidden';
    document.body.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      if(this.modalRef.nativeElement) {
        this.modalRef?.nativeElement?.setAttribute('aria-hidden', 'false');
      }
      
    }, 100);
  }
}
